// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReferralsModule-module__font-s-10___sNOZJ {
  font-size: 10px !important;
}

.ReferralsModule-module__font-s-12___f4Wgy {
  font-size: 12px !important;
}

.ReferralsModule-module__font-s-13___nSHRa {
  font-size: 13px !important;
}

.ReferralsModule-module__font-s-14___B9G6J {
  font-size: 14px !important;
}

.ReferralsModule-module__font-s-15___UpOzy {
  font-size: 15px !important;
}

.ReferralsModule-module__font-s-16___ZvPDP {
  font-size: 16px !important;
}

.ReferralsModule-module__font-s-18___ZGXJG {
  font-size: 18px !important;
}

.ReferralsModule-module__font-s-20___rQ3Kx {
  font-size: 20px !important;
}

.ReferralsModule-module__font-s-22___22zYy {
  font-size: 22px !important;
}

.ReferralsModule-module__font-s-28___ZyEW0 {
  font-size: 28px !important;
}

.ReferralsModule-module__font-w-400___LeSHh {
  font-weight: 400 !important;
}

.ReferralsModule-module__font-w-500___GHvq4 {
  font-weight: 500 !important;
}

.ReferralsModule-module__font-w-600___fl6tH {
  font-weight: 600 !important;
}

.ReferralsModule-module__font-w-700___vHzEw {
  font-weight: 700 !important;
}

.ReferralsModule-module__p-5___Gv_Cw {
  padding: 5px !important;
}

.ReferralsModule-module__p-12___YBnk9 {
  padding: 12px !important;
}

.ReferralsModule-module__p-16___NVG0b {
  padding: 16px !important;
}

.ReferralsModule-module__p-30___brp_3 {
  padding: 30px !important;
}

.ReferralsModule-module__p-b-0___wBdot {
  padding-bottom: 0 !important;
}

.ReferralsModule-module__p-b-5___CntmY {
  padding-bottom: 5px !important;
}

.ReferralsModule-module__p-b-10___QqOWI {
  padding-bottom: 10px !important;
}

.ReferralsModule-module__p-b-12___du0Iv {
  padding-bottom: 12px !important;
}

.ReferralsModule-module__p-b-16___lTWOq {
  padding-bottom: 16px !important;
}

.ReferralsModule-module__p-b-18___SE7vv {
  padding-bottom: 18px !important;
}

.ReferralsModule-module__p-b-20___bOdo0 {
  padding-bottom: 20px !important;
}

.ReferralsModule-module__p-b-25___H3rmy {
  padding-bottom: 25px !important;
}

.ReferralsModule-module__p-b-30___CHfLd {
  padding-bottom: 30px !important;
}

.ReferralsModule-module__p-b-50___nORjl {
  padding-bottom: 50px !important;
}

.ReferralsModule-module__p-t-0___XguSn {
  padding-top: 0 !important;
}

.ReferralsModule-module__p-t-12___Pp8xd {
  padding-top: 12px !important;
}

.ReferralsModule-module__p-t-16___ktX9x {
  padding-top: 16px !important;
}

.ReferralsModule-module__p-t-18___Bj1zi {
  padding-top: 18px !important;
}

.ReferralsModule-module__p-t-20___dQsYd {
  padding-top: 20px !important;
}

.ReferralsModule-module__p-t-30___wzAoG {
  padding-top: 30px !important;
}

.ReferralsModule-module__p-t-40___QidME {
  padding-top: 40px !important;
}

.ReferralsModule-module__p-t-50___X31Ff {
  padding-top: 50px !important;
}

.ReferralsModule-module__p-l-20___fx8zB {
  padding-left: 20px !important;
}

.ReferralsModule-module__p-l-30___B18rK {
  padding-left: 30px !important;
}

.ReferralsModule-module__p-l-40___qtwbI {
  padding-left: 40px !important;
}

.ReferralsModule-module__p-r-16___fqM1N {
  padding-right: 16px !important;
}

.ReferralsModule-module__p-r-20___Rr2c4 {
  padding-right: 20px !important;
}

.ReferralsModule-module__p-r-30___zF2_J {
  padding-right: 30px !important;
}

.ReferralsModule-module__p-r-50___PJu4t {
  padding-right: 50px !important;
}

.ReferralsModule-module__p-r-60___JZlxb {
  padding-right: 60px !important;
}

.ReferralsModule-module__m-b-1___IVwTo {
  margin-bottom: 1px !important;
}

.ReferralsModule-module__m-b-2___yh51k {
  margin-bottom: 2px !important;
}

.ReferralsModule-module__m-b-6___Gd12e {
  margin-bottom: 6px !important;
}

.ReferralsModule-module__m-b-8___gEWL_ {
  margin-bottom: 8px !important;
}

.ReferralsModule-module__m-b-10___udFfV {
  margin-bottom: 10px !important;
}

.ReferralsModule-module__m-b-14___ii8nt {
  margin-bottom: 14px !important;
}

.ReferralsModule-module__m-b-16___RoXUI {
  margin-bottom: 16px !important;
}

.ReferralsModule-module__m-b-20___IxqFA {
  margin-bottom: 20px !important;
}

.ReferralsModule-module__m-b-22___EJVxQ {
  margin-bottom: 22px !important;
}

.ReferralsModule-module__m-b-24___bTd3V {
  margin-bottom: 24px !important;
}

.ReferralsModule-module__m-b-30___SNDxy {
  margin-bottom: 30px !important;
}

.ReferralsModule-module__m-b-32___ZIic2 {
  margin-bottom: 32px !important;
}

.ReferralsModule-module__m-b-40___X7vlq {
  margin-bottom: 40px !important;
}

.ReferralsModule-module__m-t-2___yQs7p {
  margin-top: 2px !important;
}

.ReferralsModule-module__m-t-3___ZnIzM {
  margin-top: 3px !important;
}

.ReferralsModule-module__m-t-4___IVuBd {
  margin-top: 4px !important;
}

.ReferralsModule-module__m-t-5___uMYby {
  margin-top: 5px !important;
}

.ReferralsModule-module__m-t-8___mJNW1 {
  margin-top: 8px !important;
}

.ReferralsModule-module__m-t-10___MmZDq {
  margin-top: 10px !important;
}

.ReferralsModule-module__m-t-15___pLUeh {
  margin-top: 15px !important;
}

.ReferralsModule-module__m-t-16___hZFO6 {
  margin-top: 16px !important;
}

.ReferralsModule-module__m-t-20___GbBNu {
  margin-top: 20px !important;
}

.ReferralsModule-module__m-t-22___g_vGn {
  margin-top: 22px !important;
}

.ReferralsModule-module__m-t-30___x32Gk {
  margin-top: 30px !important;
}

.ReferralsModule-module__m-t-32___Meiuv {
  margin-top: 32px !important;
}

.ReferralsModule-module__m-l-auto___VHGR_ {
  margin-left: auto !important;
}

.ReferralsModule-module__m-l-4___Nbu0m {
  margin-left: 4px !important;
}

.ReferralsModule-module__m-l-5___MWmI1 {
  margin-left: 5px !important;
}

.ReferralsModule-module__m-l-6___jLrCi {
  margin-left: 6px !important;
}

.ReferralsModule-module__m-l-8___KFO4B {
  margin-left: 8px !important;
}

.ReferralsModule-module__m-l-10___tA2oe {
  margin-left: 10px !important;
}

.ReferralsModule-module__m-l-16___qXNVp {
  margin-left: 16px !important;
}

.ReferralsModule-module__m-l-20___Uzp_3 {
  margin-left: 20px !important;
}

.ReferralsModule-module__m-l-24____GpcS {
  margin-left: 24px !important;
}

.ReferralsModule-module__m-l-30___Onvg4 {
  margin-left: 30px !important;
}

.ReferralsModule-module__m-l-35___Hnc8F {
  margin-left: 35px !important;
}

.ReferralsModule-module__m-l-40___ulcTi {
  margin-left: 40px !important;
}

.ReferralsModule-module__m-r-8___Othzh {
  margin-right: 8px !important;
}

.ReferralsModule-module__m-r-10____4erV {
  margin-right: 10px !important;
}

.ReferralsModule-module__m-r-16___W2KAg {
  margin-right: 16px !important;
}

.ReferralsModule-module__m-r-20___Yhsvl {
  margin-right: 20px !important;
}

.ReferralsModule-module__m-r-24___OFmIw {
  margin-right: 24px !important;
}

.ReferralsModule-module__m-r-30___As_xz {
  margin-right: 30px !important;
}

.ReferralsModule-module__m-r-40___RjVy6 {
  margin-right: 40px !important;
}

.ReferralsModule-module__border-r-3___VYhZd {
  border-radius: 3px !important;
}

.ReferralsModule-module__border-r-4___BA9A1 {
  border-radius: 4px !important;
}

.ReferralsModule-module__border-r-6___ucrN1 {
  border-radius: 6px !important;
}

.ReferralsModule-module__border-r-10___aH7ZA {
  border-radius: 10px !important;
}

.ReferralsModule-module__border-r-12___enHPc {
  border-radius: 12px !important;
}

.ReferralsModule-module__border-r-16___D7IRH {
  border-radius: 16px !important;
}

.ReferralsModule-module__border-r-50___tN3KD {
  border-radius: 50% !important;
}

.ReferralsModule-module__primary-border___BnvYk {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ReferralsModule-module__primary-border-b___czWm_ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ReferralsModule-module__primary-border-t___vskIx {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ReferralsModule-module__primary-border-l___N0Wai {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ReferralsModule-module__primary-border-r___FcPue {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ReferralsModule-module__secondary-border___gVFhi {
  border: 1px solid #637768;
}

.ReferralsModule-module__secondary-border-b___fD4BP {
  border-bottom: 1px solid #637768;
}

.ReferralsModule-module__secondary-border-t___UmGbA {
  border-top: 1px solid #637768;
}

.ReferralsModule-module__secondary-border-l___MH713 {
  border-left: 1px solid #637768;
}

.ReferralsModule-module__secondary-border-r___PkZRT {
  border-right: 1px solid #637768;
}

.ReferralsModule-module__gap-0___XZNdy {
  gap: 0 !important;
}

.ReferralsModule-module__gap-2___PJe7H {
  gap: 2px !important;
}

.ReferralsModule-module__gap-4___fjnni {
  gap: 4px !important;
}

.ReferralsModule-module__gap-5___MIh74 {
  gap: 5px !important;
}

.ReferralsModule-module__gap-6___QELh3 {
  gap: 6px !important;
}

.ReferralsModule-module__gap-8___RRXIq {
  gap: 8px !important;
}

.ReferralsModule-module__gap-10___r6uXu {
  gap: 10px !important;
}

.ReferralsModule-module__gap-12___rS2ar {
  gap: 12px !important;
}

.ReferralsModule-module__gap-14___zjT4Q {
  gap: 14px !important;
}

.ReferralsModule-module__gap-16___N4I3f {
  gap: 16px !important;
}

.ReferralsModule-module__gap-18___he18G {
  gap: 18px !important;
}

.ReferralsModule-module__gap-20___PQZpj {
  gap: 20px !important;
}

.ReferralsModule-module__gap-24___Uaoda {
  gap: 24px !important;
}

.ReferralsModule-module__gap-26___BOfPu {
  gap: 26px !important;
}

.ReferralsModule-module__gap-30___GBeK6 {
  gap: 30px !important;
}

.ReferralsModule-module__gap-32___crDmi {
  gap: 32px !important;
}

.ReferralsModule-module__gap-40___B92Er {
  gap: 40px !important;
}

.ReferralsModule-module__gap-50___Ve74Y {
  gap: 50px !important;
}

.ReferralsModule-module__flex-1___izDzE {
  flex: 1;
}

.ReferralsModule-module__flex-none___wlY1Z {
  flex: none !important;
}

.ReferralsModule-module__flex-column___fMn36 {
  display: flex;
  flex-direction: column !important;
}

.ReferralsModule-module__flex-row___uRchp {
  display: flex;
  flex-direction: row !important;
}

.ReferralsModule-module__vertically-centered___M8XDe {
  display: flex;
  align-items: center !important;
}

.ReferralsModule-module__horizontally-centered___YgkAw {
  display: flex;
  justify-content: center !important;
}

.ReferralsModule-module__horizontally-end___fdY8q {
  display: flex;
  justify-content: end !important;
}

.ReferralsModule-module__vertically-start___Cs1f9 {
  display: flex;
  align-items: start !important;
}

.ReferralsModule-module__space-between___AzVUf {
  display: flex;
  justify-content: space-between !important;
}

.ReferralsModule-module__flex-wrap___z8XDq {
  flex-wrap: wrap !important;
}

.ReferralsModule-module__height-100___sjENc {
  height: 100%;
}

.ReferralsModule-module__width-50___oZWc0 {
  width: 50% !important;
}

.ReferralsModule-module__width-100___LLfL1 {
  width: 100%;
}

.ReferralsModule-module__cursor-pointer___Z_ZOT {
  cursor: pointer;
}

.ReferralsModule-module__cursor-not-allowed___Jj9cm {
  cursor: not-allowed !important;
}

.ReferralsModule-module__absolute-centered___Cj7IA {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ReferralsModule-module__absolute___F05ni {
  position: absolute;
}

.ReferralsModule-module__relative___YMQep {
  position: relative;
}

.ReferralsModule-module__fixed___iOyrW {
  position: fixed;
}

.ReferralsModule-module__visible___M7ijC {
  opacity: 1;
}

.ReferralsModule-module__invisible___FEUSf {
  opacity: 0;
}

.ReferralsModule-module__col-90___V3jPm {
  width: 90% !important;
}

.ReferralsModule-module__col-auto___IZXUw {
  width: auto !important;
}

.ReferralsModule-module__medical-tabs___fItNl {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ReferralsModule-module__medical-table-new___IuWyM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ReferralsModule-module__medical-table-new___IuWyM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ReferralsModule-module__medical-table-new___IuWyM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ReferralsModule-module__medical-table-new___IuWyM::-webkit-scrollbar-track {
  display: none;
}
.ReferralsModule-module__medical-table-new___IuWyM.ReferralsModule-module__no-pagination___PUjZW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ReferralsModule-module__medical-table-new___IuWyM.ReferralsModule-module__no-pagination___PUjZW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ReferralsModule-module__medical-table-new___IuWyM.ReferralsModule-module__no-pagination___PUjZW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ReferralsModule-module__medical-table-new___IuWyM.ReferralsModule-module__no-pagination___PUjZW::-webkit-scrollbar-track {
  display: none;
}

.ReferralsModule-module__medical-table-empty___Oihdk {
  padding: 14px 40px !important;
}

.ReferralsModule-module__icon-btn___TgKJK {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ReferralsModule-module__search-icon___dII10 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ReferralsModule-module__disable-select___gnafs {
  user-select: none;
}

.ReferralsModule-module__break-word___y0h0p {
  word-break: break-word;
}

.ReferralsModule-module__popup-clear-btn___A5I5a {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ReferralsModule-module__scroll-m-b-20___VATqE {
  scroll-margin-bottom: 20px;
}

.ReferralsModule-module__container___ovysB {
  color: #375844;
  margin-bottom: -6px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/ReferralsModule/ReferralsModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,mBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  margin-bottom: -6px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ReferralsModule-module__font-s-10___sNOZJ`,
	"fontS12": `ReferralsModule-module__font-s-12___f4Wgy`,
	"fontS13": `ReferralsModule-module__font-s-13___nSHRa`,
	"fontS14": `ReferralsModule-module__font-s-14___B9G6J`,
	"fontS15": `ReferralsModule-module__font-s-15___UpOzy`,
	"fontS16": `ReferralsModule-module__font-s-16___ZvPDP`,
	"fontS18": `ReferralsModule-module__font-s-18___ZGXJG`,
	"fontS20": `ReferralsModule-module__font-s-20___rQ3Kx`,
	"fontS22": `ReferralsModule-module__font-s-22___22zYy`,
	"fontS28": `ReferralsModule-module__font-s-28___ZyEW0`,
	"fontW400": `ReferralsModule-module__font-w-400___LeSHh`,
	"fontW500": `ReferralsModule-module__font-w-500___GHvq4`,
	"fontW600": `ReferralsModule-module__font-w-600___fl6tH`,
	"fontW700": `ReferralsModule-module__font-w-700___vHzEw`,
	"p5": `ReferralsModule-module__p-5___Gv_Cw`,
	"p12": `ReferralsModule-module__p-12___YBnk9`,
	"p16": `ReferralsModule-module__p-16___NVG0b`,
	"p30": `ReferralsModule-module__p-30___brp_3`,
	"pB0": `ReferralsModule-module__p-b-0___wBdot`,
	"pB5": `ReferralsModule-module__p-b-5___CntmY`,
	"pB10": `ReferralsModule-module__p-b-10___QqOWI`,
	"pB12": `ReferralsModule-module__p-b-12___du0Iv`,
	"pB16": `ReferralsModule-module__p-b-16___lTWOq`,
	"pB18": `ReferralsModule-module__p-b-18___SE7vv`,
	"pB20": `ReferralsModule-module__p-b-20___bOdo0`,
	"pB25": `ReferralsModule-module__p-b-25___H3rmy`,
	"pB30": `ReferralsModule-module__p-b-30___CHfLd`,
	"pB50": `ReferralsModule-module__p-b-50___nORjl`,
	"pT0": `ReferralsModule-module__p-t-0___XguSn`,
	"pT12": `ReferralsModule-module__p-t-12___Pp8xd`,
	"pT16": `ReferralsModule-module__p-t-16___ktX9x`,
	"pT18": `ReferralsModule-module__p-t-18___Bj1zi`,
	"pT20": `ReferralsModule-module__p-t-20___dQsYd`,
	"pT30": `ReferralsModule-module__p-t-30___wzAoG`,
	"pT40": `ReferralsModule-module__p-t-40___QidME`,
	"pT50": `ReferralsModule-module__p-t-50___X31Ff`,
	"pL20": `ReferralsModule-module__p-l-20___fx8zB`,
	"pL30": `ReferralsModule-module__p-l-30___B18rK`,
	"pL40": `ReferralsModule-module__p-l-40___qtwbI`,
	"pR16": `ReferralsModule-module__p-r-16___fqM1N`,
	"pR20": `ReferralsModule-module__p-r-20___Rr2c4`,
	"pR30": `ReferralsModule-module__p-r-30___zF2_J`,
	"pR50": `ReferralsModule-module__p-r-50___PJu4t`,
	"pR60": `ReferralsModule-module__p-r-60___JZlxb`,
	"mB1": `ReferralsModule-module__m-b-1___IVwTo`,
	"mB2": `ReferralsModule-module__m-b-2___yh51k`,
	"mB6": `ReferralsModule-module__m-b-6___Gd12e`,
	"mB8": `ReferralsModule-module__m-b-8___gEWL_`,
	"mB10": `ReferralsModule-module__m-b-10___udFfV`,
	"mB14": `ReferralsModule-module__m-b-14___ii8nt`,
	"mB16": `ReferralsModule-module__m-b-16___RoXUI`,
	"mB20": `ReferralsModule-module__m-b-20___IxqFA`,
	"mB22": `ReferralsModule-module__m-b-22___EJVxQ`,
	"mB24": `ReferralsModule-module__m-b-24___bTd3V`,
	"mB30": `ReferralsModule-module__m-b-30___SNDxy`,
	"mB32": `ReferralsModule-module__m-b-32___ZIic2`,
	"mB40": `ReferralsModule-module__m-b-40___X7vlq`,
	"mT2": `ReferralsModule-module__m-t-2___yQs7p`,
	"mT3": `ReferralsModule-module__m-t-3___ZnIzM`,
	"mT4": `ReferralsModule-module__m-t-4___IVuBd`,
	"mT5": `ReferralsModule-module__m-t-5___uMYby`,
	"mT8": `ReferralsModule-module__m-t-8___mJNW1`,
	"mT10": `ReferralsModule-module__m-t-10___MmZDq`,
	"mT15": `ReferralsModule-module__m-t-15___pLUeh`,
	"mT16": `ReferralsModule-module__m-t-16___hZFO6`,
	"mT20": `ReferralsModule-module__m-t-20___GbBNu`,
	"mT22": `ReferralsModule-module__m-t-22___g_vGn`,
	"mT30": `ReferralsModule-module__m-t-30___x32Gk`,
	"mT32": `ReferralsModule-module__m-t-32___Meiuv`,
	"mLAuto": `ReferralsModule-module__m-l-auto___VHGR_`,
	"mL4": `ReferralsModule-module__m-l-4___Nbu0m`,
	"mL5": `ReferralsModule-module__m-l-5___MWmI1`,
	"mL6": `ReferralsModule-module__m-l-6___jLrCi`,
	"mL8": `ReferralsModule-module__m-l-8___KFO4B`,
	"mL10": `ReferralsModule-module__m-l-10___tA2oe`,
	"mL16": `ReferralsModule-module__m-l-16___qXNVp`,
	"mL20": `ReferralsModule-module__m-l-20___Uzp_3`,
	"mL24": `ReferralsModule-module__m-l-24____GpcS`,
	"mL30": `ReferralsModule-module__m-l-30___Onvg4`,
	"mL35": `ReferralsModule-module__m-l-35___Hnc8F`,
	"mL40": `ReferralsModule-module__m-l-40___ulcTi`,
	"mR8": `ReferralsModule-module__m-r-8___Othzh`,
	"mR10": `ReferralsModule-module__m-r-10____4erV`,
	"mR16": `ReferralsModule-module__m-r-16___W2KAg`,
	"mR20": `ReferralsModule-module__m-r-20___Yhsvl`,
	"mR24": `ReferralsModule-module__m-r-24___OFmIw`,
	"mR30": `ReferralsModule-module__m-r-30___As_xz`,
	"mR40": `ReferralsModule-module__m-r-40___RjVy6`,
	"borderR3": `ReferralsModule-module__border-r-3___VYhZd`,
	"borderR4": `ReferralsModule-module__border-r-4___BA9A1`,
	"borderR6": `ReferralsModule-module__border-r-6___ucrN1`,
	"borderR10": `ReferralsModule-module__border-r-10___aH7ZA`,
	"borderR12": `ReferralsModule-module__border-r-12___enHPc`,
	"borderR16": `ReferralsModule-module__border-r-16___D7IRH`,
	"borderR50": `ReferralsModule-module__border-r-50___tN3KD`,
	"primaryBorder": `ReferralsModule-module__primary-border___BnvYk`,
	"primaryBorderB": `ReferralsModule-module__primary-border-b___czWm_`,
	"primaryBorderT": `ReferralsModule-module__primary-border-t___vskIx`,
	"primaryBorderL": `ReferralsModule-module__primary-border-l___N0Wai`,
	"primaryBorderR": `ReferralsModule-module__primary-border-r___FcPue`,
	"secondaryBorder": `ReferralsModule-module__secondary-border___gVFhi`,
	"secondaryBorderB": `ReferralsModule-module__secondary-border-b___fD4BP`,
	"secondaryBorderT": `ReferralsModule-module__secondary-border-t___UmGbA`,
	"secondaryBorderL": `ReferralsModule-module__secondary-border-l___MH713`,
	"secondaryBorderR": `ReferralsModule-module__secondary-border-r___PkZRT`,
	"gap0": `ReferralsModule-module__gap-0___XZNdy`,
	"gap2": `ReferralsModule-module__gap-2___PJe7H`,
	"gap4": `ReferralsModule-module__gap-4___fjnni`,
	"gap5": `ReferralsModule-module__gap-5___MIh74`,
	"gap6": `ReferralsModule-module__gap-6___QELh3`,
	"gap8": `ReferralsModule-module__gap-8___RRXIq`,
	"gap10": `ReferralsModule-module__gap-10___r6uXu`,
	"gap12": `ReferralsModule-module__gap-12___rS2ar`,
	"gap14": `ReferralsModule-module__gap-14___zjT4Q`,
	"gap16": `ReferralsModule-module__gap-16___N4I3f`,
	"gap18": `ReferralsModule-module__gap-18___he18G`,
	"gap20": `ReferralsModule-module__gap-20___PQZpj`,
	"gap24": `ReferralsModule-module__gap-24___Uaoda`,
	"gap26": `ReferralsModule-module__gap-26___BOfPu`,
	"gap30": `ReferralsModule-module__gap-30___GBeK6`,
	"gap32": `ReferralsModule-module__gap-32___crDmi`,
	"gap40": `ReferralsModule-module__gap-40___B92Er`,
	"gap50": `ReferralsModule-module__gap-50___Ve74Y`,
	"flex1": `ReferralsModule-module__flex-1___izDzE`,
	"flexNone": `ReferralsModule-module__flex-none___wlY1Z`,
	"flexColumn": `ReferralsModule-module__flex-column___fMn36`,
	"flexRow": `ReferralsModule-module__flex-row___uRchp`,
	"verticallyCentered": `ReferralsModule-module__vertically-centered___M8XDe`,
	"horizontallyCentered": `ReferralsModule-module__horizontally-centered___YgkAw`,
	"horizontallyEnd": `ReferralsModule-module__horizontally-end___fdY8q`,
	"verticallyStart": `ReferralsModule-module__vertically-start___Cs1f9`,
	"spaceBetween": `ReferralsModule-module__space-between___AzVUf`,
	"flexWrap": `ReferralsModule-module__flex-wrap___z8XDq`,
	"height100": `ReferralsModule-module__height-100___sjENc`,
	"width50": `ReferralsModule-module__width-50___oZWc0`,
	"width100": `ReferralsModule-module__width-100___LLfL1`,
	"cursorPointer": `ReferralsModule-module__cursor-pointer___Z_ZOT`,
	"cursorNotAllowed": `ReferralsModule-module__cursor-not-allowed___Jj9cm`,
	"absoluteCentered": `ReferralsModule-module__absolute-centered___Cj7IA`,
	"absolute": `ReferralsModule-module__absolute___F05ni`,
	"relative": `ReferralsModule-module__relative___YMQep`,
	"fixed": `ReferralsModule-module__fixed___iOyrW`,
	"visible": `ReferralsModule-module__visible___M7ijC`,
	"invisible": `ReferralsModule-module__invisible___FEUSf`,
	"col90": `ReferralsModule-module__col-90___V3jPm`,
	"colAuto": `ReferralsModule-module__col-auto___IZXUw`,
	"medicalTabs": `ReferralsModule-module__medical-tabs___fItNl`,
	"medicalTableNew": `ReferralsModule-module__medical-table-new___IuWyM`,
	"noPagination": `ReferralsModule-module__no-pagination___PUjZW`,
	"medicalTableEmpty": `ReferralsModule-module__medical-table-empty___Oihdk`,
	"iconBtn": `ReferralsModule-module__icon-btn___TgKJK`,
	"searchIcon": `ReferralsModule-module__search-icon___dII10`,
	"disableSelect": `ReferralsModule-module__disable-select___gnafs`,
	"breakWord": `ReferralsModule-module__break-word___y0h0p`,
	"popupClearBtn": `ReferralsModule-module__popup-clear-btn___A5I5a`,
	"scrollMB20": `ReferralsModule-module__scroll-m-b-20___VATqE`,
	"container": `ReferralsModule-module__container___ovysB`
};
module.exports = ___CSS_LOADER_EXPORT___;
